import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  component: {
    display: "flex",
    flex: "auto",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.dark
  }
}));
